import { useSearchParams } from "react-router-dom";

export const usePagination = (defaultLimit = 10, defaultOffset = 0) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const limit = defaultLimit;
  const offset = parseInt(searchParams.get("offset")) || defaultOffset;

  const updateOffset = (newOffset) => {
    setSearchParams({ offset: newOffset.toString() });
  };

  const goToNext = (currentLimit, currentOffset) => {
    updateOffset(currentOffset);
  };

  const goToBack = (currentLimit, currentOffset) => {
    updateOffset(currentOffset);
  };

  return {
    limit,
    offset,
    updateOffset,
    goToNext,
    goToBack,
  };
};
